/** @format */

export enum ACTION_TYPES {
	SET_PM_PROMOTIONS = 'SET_PM_PROMOTIONS',
	SET_ERROR_FOR_PM_PROMOTIONS = 'SET_ERROR_FOR_PM_PROMOTIONS',
}
